/**
 * Donation Only — full article page for the "Donation Only" sharing
 * option under Urban Harvest.
 *
 * Route: /food-pulse/urban-harvest/donation-only
 */
import { Heart } from "lucide-react";
import UrbanHarvestArticleLayout, { UH_PALETTE } from "@/components/UrbanHarvestArticleLayout";

export default function FoodPulseUrbanHarvestDonationOnly() {
  return (
    <UrbanHarvestArticleLayout
      slug="donation-only"
      title="Donation Only"
      subtitle="Turn Your Surplus Into Hope"
      icon={Heart}
      accent={UH_PALETTE.orange}
      body={[
        "Fresh fruits and vegetables are among the most requested yet least available foods at many food banks and community meal programs. Through the Donation Only option, FoodPulse makes it easy to direct your surplus harvest to organizations that serve people experiencing food insecurity.",
        "When you select Donation Only, participating food banks, community kitchens, shelters, or approved nonprofit organizations can arrange collection according to your preferences and availability. Your harvest stays within the community where it can make an immediate difference.",
        "Whether your garden produces a few extra pounds of vegetables or your fruit trees yield hundreds of pounds each season, your generosity helps provide healthier meals while reducing unnecessary waste.",
        "FoodPulse coordinates the donation process, tracks contributions if you choose, and helps participating organizations identify available produce throughout the harvest season.",
      ]}
      pullquote="Every donated apple, orange, avocado, tomato, or bunch of herbs represents more than food — it represents kindness, dignity, and community."
      closer="Together, we can ensure that more locally grown food reaches tables instead of landfills."
    />
  );
}
